/*
 * @Author: Teemo Ding
 * @Date: 2022-04-14 16:58:46
 * @LastEditTime: 2022-05-12 08:47:18
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Permissions/PermissionList/TransferStoreOwnership/index.tsx
 */
import { Button } from '@/src/components/Antd';
import ErrorModalTitle from '@/src/components/ErrorModal/ErrorModalTitle';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import React from 'react';
import ModalHoc from 'src/constrains/ModalHOC';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import TransferOwnershipModal from '../../Components/TransferOwnershipModal';
import css from '../style.module.less';

const TransferStoreOwnership = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    modalOp: { setShowModal, setModalTitle, setModalContent },
    onUpdate,
  } = props;

  const handleCancel = () => {
    setShowModal(false);
  };

  const handelTransfer = () => {
    setShowModal(true);
    setModalTitle(
      <ErrorModalTitle>
        {getI18n('usersAndPermissions.list.transferStoreOwnershipTitle')}
      </ErrorModalTitle>,
    );
    setModalContent(
      <TransferOwnershipModal onCancel={handleCancel} onUpdate={onUpdate} />,
    );
  };

  return (
    <SectionWrapper
      titleClassName={css.titleContainer}
      containerClassName={css.containerClassName}
      title={getI18n('usersAndPermissions.list.transferStoreOwnershipTitle')}>
      <p className={css.ownershipTitle}>
        {getI18n('usersAndPermissions.list.transferStoreOwnershipTitle')}
      </p>
      <p className={css.ownershipText}>
        {getI18n('usersAndPermissions.list.transferStoreOwnershipContent')}
      </p>
      <Button type='primary' onClick={handelTransfer} className={css.addUser}>
        {getI18n('usersAndPermissions.list.transferOwnership')}
      </Button>
    </SectionWrapper>
  );
};

export default ModalHoc(TransferStoreOwnership);
